import { render, staticRenderFns } from "./ProjectInfo.vue?vue&type=template&id=1574e76b&"
import script from "./ProjectInfo.vue?vue&type=script&lang=ts&"
export * from "./ProjectInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports